
import { Component, Vue } from 'vue-property-decorator'
import { MediaService } from '@/services/index'
import { isValidURL } from '@/common/utils'
import { Form as ElForm } from 'element-ui'

@Component({
    name: 'MediaOrgEdit',
    components: {
    }
})
export default class extends Vue {

    private validateURL = (rule: any, value: string, callback: Function) => {
        if (!isValidURL(value)) {
            callback(new Error('请输入正确的URL'))
        } else {
            callback()
        }
    }

    private orgRules = {
        name: [
            { required: true, message: '请输入集团名称', trigger: 'blur' },
            { min: 2, max: 20, message: '集团名称长度为2~20位', trigger: 'blur' }
        ]
    }

    private orgForm = {
        name: '',
        url: '',
        intro: '',
        medias: []
    }
    private isCreateLoading: boolean = false
    private isSearching: boolean = false
    private mediaOptions = []

    private async fetchMedia(query: any) {
        if (query !== '') {
            this.isSearching = true
            const result = await MediaService.searchMedia({ value: query })
            if (result.status === 200) {
                this.mediaOptions = result.data.map((item: any) => {
                    return { value: item.id, label: item.name }
                })
            }
            this.isSearching = false
        } else {
            this.mediaOptions = []
        }
    }

    private onSelectChange() {
        (this.$refs.orgForm as ElForm).validateField('medias')
    }

    private onCreate() {
        (this.$refs.orgForm as ElForm).validate(async(valid: boolean) => {
            if (valid) {
                this.isCreateLoading = true
                const result = await MediaService.createOrg(this.orgForm)
                if (result.status === 200) {
                    (this.$refs.orgForm as ElForm).resetFields()
                    this.orgForm.medias = []
                    this.$message({ type: 'success', message: '创建成功' })
                } else if (result.status === 400) {
                    this.$message({ type: 'warning', message: '数据已存在' })
                } else {
                    this.$message({ type: 'error', message: '创建集团失败' })
                }
                this.isCreateLoading = false
            } else {
                return false
            }
        })
    }

    private onCancel() {
        this.$router.go(-1)
    }
}
